export default "__VITE_ASSET__9c502845__"